<template>
  <div>
    <h1>Email Verification</h1>

    <p v-if="tokenStatus == 'checking'">
      Loading...
    </p>
    <p
      v-else-if="tokenStatus == 'valid'"
    >
      Your email address was successfully verified! You may now
      <router-link :to="{name: 'login'}">
        log in
      </router-link>
    </p>
    <div
      v-else-if="tokenStatus == 'error'"
      class="alert alert-danger"
      role="alert"
    >
      Unable to communicate with the server. Please check your connection and
      try again.
      <a
        href="javascript:void(0);"
        class="btn btn-outline-danger btn-sm"
        @click="checkEmailVerificationLink"
      >Try again</a>
    </div>
    <p
      v-else-if="tokenStatus == 'invalid'"
      class="alert alert-danger"
      role="alert"
    >
      The email verification link was invalid.
    </p>
  </div>
</template>

<script>
export default {
  name: 'VerifyEmail',
  title() {
    return 'Verify Email';
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tokenStatus: 'checking',
    };
  },
  mounted() {
    this.checkEmailVerificationLink();
  },
  methods: {
    async checkEmailVerificationLink() {
      this.tokenStatus = 'checking';

      const data = {
        token: this.token,
      };

      const responseData = await this.api({
        url: 'users/check_email_verification_link/',
        method: 'POST',
        json: data,
      });

      if (responseData.status === 200) {
        this.tokenStatus = responseData.body.valid ? 'valid' : 'invalid';
      } else {
        this.tokenStatus = 'error';
      }
    },
  },
};
</script>
